import { CuriosityFilterByType, CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';
import { CuriosityAutocompleteFieldWithController, FormFieldSize } from '@procureai/ui-form-mui';
import { ReactNode } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ContractDemandRequestItem } from '~/modules/contractDemands/ContractDemandRequestWidget/components/ContractDemandRequestLineItems/ContractDemandRequestItemForm.schema.ts';

export interface CommodityOrganizationSelectProps {
  viewOnly?: boolean;
  label?: ReactNode;
  size?: FormFieldSize;
  fullWidth?: boolean;
}

export const CommodityOrganizationSelect = ({ ...props }: CommodityOrganizationSelectProps) => {
  const { control } = useFormContext<ContractDemandRequestItem>();
  const commodityId = useWatch({ control, name: 'commodityId' });
  return (
    <CuriosityAutocompleteFieldWithController
      control={control}
      name="organizationId"
      ns={CuriosityNamespaceType.ORGANIZATION}
      disabled={!commodityId}
      filter={
        commodityId
          ? {
              by: CuriosityFilterByType.COMMODITY_ID,
              value: commodityId,
            }
          : undefined
      }
      {...props}
    />
  );
};
